// Ejemplo1: validarIBAN("ES00 1234 5678 0612 3456 7890") --> false
// Ejemplo2: validarIBAN("ES68 1234 5678 0612 3456 7890") --> true
export const isValidIban = (value) => {
  if (!value || value === "") return true;
  const rearrange = value.substring(4, value.length) + value.substring(0, 4);
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split('');
  let alphaMap = {};
  let number = [];

  alphabet.forEach((value, index) => alphaMap[value] = index + 10 );

  rearrange.split('').forEach((value, index) => {
    number[index] = alphaMap[value] || value;
  });

  return modulo(number.join('').toString(), 97) === 1;
}

const modulo = (aNumStr, aDiv) => {
  let tmp = "";
  let i, r;
  for (i = 0; i < aNumStr.length; i++) {
    tmp += aNumStr.charAt(i);
    r = tmp % aDiv;
    tmp = r.toString();
  }
  return tmp / 1;
}
